import React, { useEffect } from 'react'
import { Navbar, Nav, NavDropdown } from 'react-bootstrap'
import './styles.css'
import { connect } from 'react-redux'
import { withRouter, NavLink } from 'react-router-dom'
import { fetchUserInfo } from "../../actions/okta";
import logo from "../../assets/img/logo.png";
//import { other } from '../Profile/sidebar/sectionTypes'
import { showModal } from "../../actions/modal";
import Modal from "../misc/modal";

function NavBarTopFC(props) {
  const {
    sections,
    user,
    modal,
    contributor,
    is_user_editor,
    setShowModal,
  } = props;


  
  const handleLink = (e, hash) => {
    if (!hash) {
      return false;
    }
    e.preventDefault();
    document.querySelectorAll(".navbar-toggler")[0].click();
    if (hash) window.location.hash = hash;
    return true;
  };

  const handleFullLink = () => {
    document.querySelectorAll(".navbar-toggler")[0].click();
    return true;
  };

  if(!user){
    return null
  }

  return (
    <React.Fragment>
      <Navbar bg="light" className="nav-light fixed-top" expand="lg">
        <NavLink className="navbar-brand" to="/" onClick={(e) => handleLink(e)}>
          <img
            className="gcf-logo"
            src={logo}
            alt="logo"
            width="24"
            height="24"
          />{" "}
          Contributor Engagement
        </NavLink>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse>
          <Nav className="mr-auto">
            <NavLink
              className="nav-link"
              to="/disclaimer"
              onClick={(e) => handleLink(e)}
            >
              <i className="fas fa-info-circle" /> Disclaimer
            </NavLink>
            {is_user_editor && (
              <NavLink
                className="nav-link"
                to="/modules/print"
                onClick={(e) => handleLink(e)}
              >
                <i className="fas fa-print" /> Custom Print
              </NavLink>
            )}
            {sections && <NavDropdown.Divider />}
            {sections &&
              sections.map((section, idx) => (
                <a
                  key={idx}
                  className="nav-link d-sm-none"
                  href={`#section-${section.id}`}
                  onClick={(e) => handleLink(e, `#section-${section.id}`)}
                >
                  <i
                    className={`fas fa-${
                      section.icon ||
                      (section.confidential ? "lock" : "hashtag")
                    }`}
                  ></i>{" "}
                  <span>{section.label}</span>
                </a>
              ))}
            {sections && is_user_editor && contributor ? (
              <NavLink
                className="nav-link d-sm-none"
                to={`/contributor/${contributor.ContributorID}/audit`}
                onClick={(e) => handleFullLink()}
              >
                <i className={`fas fa-lock`}></i> <span>Audit Trail</span>
              </NavLink>
            ) : null}
            <NavDropdown.Divider />
          </Nav>
          <Nav>
            <React.Fragment>
              <span className="navbar-text">
                <span className="hidden-sm-up"> {user.name}</span>{" "}
                <img
                  src={`https://ipmsapplication.blob.core.windows.net/profile/${user.email || user.username}.jpg`}
                  className="img-icon d-inline-block align-top rounded-circle"
                  alt=""
                />
              </span>
            </React.Fragment>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
      {modal && <Modal onCloseModal={() => setShowModal(null)} modal={modal} />}
    </React.Fragment>
  );
}

const mapStateToProps = ({ okta, general, modal }) => {
  return {
    sections: general.sections,
    groups: okta.groups,
    user: okta.user,
    isOktaFetching: okta.isFetching,
    modal: modal.modal,
    is_user_editor: okta.is_user_editor,
    contributor: general.contributor,
  };
};


export default withRouter(connect(
    mapStateToProps
)(NavBarTopFC))